{
  "commandPalette": {
    "hint": "Search & navigate · ⌘K",
    "placeholder": "Where to go…",
    "empty": "Nothing found",
    "general": "General",
    "projects": "Projects",
    "newProject": "New project",
    "aiSettings": "AI settings",
    "systemPrompts": "System prompts",
    "mcp": "Claude / MCP",
    "profile": "Profile",
    "about": "Company overview"
  },
  "nav": {
    "groups": {
      "workspace": "Workspace",
      "production": "Production",
      "assets": "Assets",
      "settings": "Additional"
    },
    "items": {
      "overview": "Overview",
      "feed": "Feed",
      "tasks": "Tasks",
      "seasons": "Seasons & episodes",
      "script": "Script",
      "studio": "Studio",
      "studioAssembly": "Studio and assembly",
      "animatics": "Animatics",
      "storyboard": "Storyboard",
      "flow": "Flow",
      "assembly": "Assembly",
      "canvas": "Canvas",
      "characters": "Characters",
      "locations": "Locations",
      "props": "Props",
      "scenes_3d": "3D Scenes",
      "presets": "Presets",
      "camera_presets": "Cameras",
      "library": "Library",
      "versions": "Versions",
      "settings": "Settings",
      "team": "Team",
      "billing": "Billing",
      "generation_skills": "Skills",
      "analytics": "Analytics"
    }
  },
  "shell": {
    "nav": {
      "loading": "Loading page",
      "stalled": "The page is taking longer than usual to load",
      "reload": "Reload"
    },
    "root": {
      "feed": "Feed",
      "projects": "Projects",
      "tasks": "Tasks",
      "newProject": "New project"
    },
    "studio": {
      "aiSettings": "AI settings",
      "systemPrompts": "Prompts",
      "agreements": "Agreements",
      "styleCatalog": "Style catalog",
      "cameras": "Cameras",
      "presentations": "Presentations",
      "splashAnnouncements": "Announcements",
      "generationModels": "Model registry",
      "providerConnections": "Providers",
      "platformConfig": "Platform",
      "skills": "Skills"
    },
    "monitoring": {
      "generations": "Generations",
      "dialogs": "Agents",
      "queueJobs": "Job queues",
      "section": "Monitoring"
    },
    "billing": {
      "dashboard": "Dashboard",
      "usage": "Journal",
      "plans": "Plans",
      "promotions": "Promotions",
      "promoCodes": "Promo codes",
      "accounts": "Accounts",
      "invoices": "Invoices",
      "proposals": "Proposals",
      "spendReports": "Spend reports",
      "onlinePayments": "Online payments",
      "supplier": "Billing details",
      "priceList": "Price list",
      "costRates": "Cost rates",
      "section": "Billing",
      "tariffs": "Tariffs"
    },
    "company": {
      "overview": "Overview",
      "aiSettings": "AI settings",
      "canvas": "Canvas",
      "prompts": "Prompts",
      "cameras": "Cameras",
      "members": "Members",
      "models": "Models",
      "skills": "Skills",
      "billing": "Billing"
    },
    "sidebar": {
      "expandMenu": "Expand menu",
      "collapseMenu": "Collapse menu",
      "platform": "Platform",
      "studio": "Studio",
      "company": "Company",
      "companies": "Companies",
      "users": "Users",
      "projects": "Project catalog",
      "catalogs": "Catalogs",
      "logout": "Log out",
      "logoutConfirm": "Log out of your account?",
      "openMenu": "Open menu",
      "closeMenu": "Close menu"
    },
    "companyHeader": {
      "railTooltip": "{{company}} · {{role}}",
      "superAdmin": "Superadmin",
      "archivedBadge": "Archived",
      "archivedTooltip": "{{company}} · archived"
    },
    "spendLimit": {
      "title": "Spending limit",
      "tooltip": "Month: {{left}} left · {{resets}}",
      "month": "Month · {{limit}}",
      "topup": "including {{amount}} until the end of the month"
    },
    "companyMenu": {
      "open": "Switch company",
      "invitations": "Invitations · {{count}}",
      "accept": "Accept",
      "decline": "Decline",
      "createCompany": "Create company",
      "about": "Company overview",
      "search": "Find a company…",
      "searchEmpty": "Nothing found",
      "close": "Close",
      "favorites": "Favorites",
      "recent": "Recent",
      "favoritesEmpty": "Star the companies you open most often and they will appear here.",
      "recentEmpty": "Companies you recently switched to will appear here.",
      "addFavorite": "Add to favorites",
      "removeFavorite": "Remove from favorites",
      "hide": "Hide from list",
      "unhide": "Show in list",
      "hidden": "Hidden · {{count}}"
    },
    "userMenu": {
      "open": "Account menu",
      "profile": "Profile",
      "language": "Language",
      "languageRu": "Русский",
      "languageEn": "English",
      "back": "Back",
      "theme": "Theme",
      "themeDark": "Dark",
      "themeLight": "Light"
    },
    "invitationBanner": {
      "prefix": "You're invited to",
      "suffix": "as {{role}}",
      "roleAs": {
        "owner": "an Owner",
        "member": "a Member"
      },
      "dismiss": "Hide until next sign-in"
    },
    "header": {
      "search": "Search",
      "jobs": "Jobs",
      "savingToDisk": "Saving to disk",
      "contextAria": "Context",
      "agentColumnShow": "Show agent",
      "agentColumnHide": "Hide agent",
      "agentReply": "Agent replied"
    },
    "drawer": {
      "closePanel": "Close panel",
      "settings": "Settings",
      "jobs": "Jobs",
      "agents": "Agents",
      "notes": "Notes",
      "versions": "Versions",
      "openProjectForModels": "Open a project to configure models.",
      "openProjectForJobs": "Open a project to view jobs."
    },
    "error": {
      "hideDetails": "Hide details",
      "showDetails": "Details"
    },
    "openRouter": {
      "checkGeneration": "Check generation",
      "checkHint": "Paste generation_id from OpenRouter Dashboard to recover the image.",
      "check": "Check",
      "enterGenerationId": "Enter generation_id.",
      "imageSaved": "Image saved.",
      "imageNotFound": "Image not found.",
      "networkUnavailable": "Network unavailable.",
      "request": "Request",
      "response": "Response",
      "payloadNotSaved": "Payload not saved",
      "responseNotSaved": "Response not saved",
      "noSavedLogs": "No saved request logs."
    },
    "recover": {
      "checkAndFetch": "Check generation and fetch file",
      "hint": "We will poll the task by its ID and save the result if it is ready.",
      "checking": "Checking…",
      "fetched": "Video fetched and saved.",
      "failed": "Could not fetch the file.",
      "networkUnavailable": "Network unavailable."
    },
    "versions": {
      "scope": {
        "scenes": "Scenes",
        "episodes": "Episodes",
        "characters": "Characters",
        "season_structure": "Season",
        "shots": "Shots"
      },
      "restoreHint": {
        "episodes": "Replaces all episodes in the selected season and nested scenes and shots with the snapshot state. Current state is saved to a new version record first.",
        "scenes": "Archives current active scenes and shots in the episode and restores the tree from the snapshot. Media and old scene records remain in the database."
      },
      "intro": "Snapshots before regeneration. Restoring «scenes» does not delete old records and attachments — they are archived.",
      "fullHistoryLink": "Full history and JSON →",
      "openProject": "Open a project to see snapshots.",
      "noSnapshots": "No automatic snapshots yet.",
      "restoreConfirm": "{{hint}}\n\nContinue restoring snapshot «{{label}}»?",
      "makeActive": "Make active",
      "doubleClickRestore": "Double-click to restore from snapshot (with confirmation)",
      "restoreUnavailable": "Restore unavailable."
    },
    "admin": {
      "title": "Administration",
      "search": "Find a section: companies, prompts, cost rates…",
      "close": "Close",
      "favorites": "Favorites",
      "recent": "Recent",
      "favoritesEmpty": "Star the sections you open most often and they will appear here.",
      "recentEmpty": "Sections you open from this menu will appear here.",
      "attention": "Needs attention",
      "noResults": "No matching sections. Try another word, like “payment” or “models”.",
      "addFavorite": "Add to favorites",
      "removeFavorite": "Remove from favorites"
    },
    "adminGroups": {
      "generation": "Generation",
      "service": "Service"
    }
  },
  "appReload": {
    "hint": "Reload the page to continue working.",
    "hintOutdated": "A new version of the app is available — reload the page.",
    "action": "Reload",
    "bannerText": "A new version of the app is available",
    "bannerDismiss": "Dismiss"
  }
}
